<template>
    <div class="panel">
        <div class="panel_head fx fx-m_between fx-c_start">
            <el-form :inline="true" :model="form" >
                <el-form-item label="关键词">
                    <el-input v-model="form.keywords" placeholder="关键词"></el-input>
                </el-form-item>
                <el-form-item label="是否在职">
                    <el-select v-model="form.enable" clearable  placeholder="是否启用">
                        <el-option label="在职" :value="true"></el-option>
                        <el-option label="离职" :value="false"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <el-button type="primary" @click="add()">新增</el-button>
        </div>
        <div class="panel_body">
            <el-table
                :data="tableData"
                stripe
                style="width: 100%">
                <el-table-column
                    min-width="180"
                    prop="name"
                    label="员工姓名" >
                </el-table-column>
                <el-table-column
                    min-width="180"
                    prop="phone"
                    label="手机号" >
                </el-table-column>
                <el-table-column
                    prop="sn"
                    min-width="180"
                    label="系统账号" >
                </el-table-column>
                <el-table-column
                    v-if="showSSO"
                    prop="ssoToken"
                    min-width="260"
                    label="单点登录token" >
                </el-table-column>
                <el-table-column
                    prop="score"
                    min-width="180"
                    label="积分" >
                </el-table-column>
                <el-table-column
                    min-width="120"
                    label="是否在职" >
                    <template slot-scope="scope">
                        <el-switch v-model="scope.row.enable"
                                   @change="modifyEnable(scope.row)"
                                   inactive-color="#ff4949">
                        </el-switch>
                    </template>
                </el-table-column>
                <el-table-column
                    min-width="180"
                    prop="createTime"
                    label="创建时间" >
                </el-table-column>
                <el-table-column
                    min-width="180"
                    prop="expireTime"
                    label="使用期限" >
                </el-table-column>
                <el-table-column
                    label="操作"
                    width="150"
                >
                    <template slot-scope="scope">
                        <div class="fx fx-m_between fx-c_center">
                            <el-link type="primary" @click="edit(scope.row)"
                                     :underline="false" ><i class="iconfont icon-bianji"></i><b>编辑</b></el-link>
                            <el-popconfirm @onConfirm="remove(scope.row)"
                                           title="确认移除该员工吗？"
                            >
                                <div slot="reference" class="fx fx-center">
                                    <el-button type="danger" icon="el-icon-minus" circle size="mini" style="padding: 2px"></el-button>
                                     <span class="remove_btn ">移除</span>
                                </div>
                            </el-popconfirm>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="panel_foot fx fx-m_end fx-c_center">
            <el-pagination
                :background="true"
                prev-text="上一页"
                next-text="下一页"
                layout="prev, pager, next"
                :current-page="pager.currentPage"
                :page-size="pager.pageSize"
                :total="pager.dataTotal"
                @current-change="pageChange"
            >
            </el-pagination>
        </div>

        <EditDraw v-if="showEdit" @submit="loadData"
                       @close="showEdit=false" :item="editItem"></EditDraw>
        <AddDraw v-if="showAdd" @submit="loadData"
                       @close="showAdd=false" :item="editItem"></AddDraw>
    </div>
</template>

<style scoped>
    .remove_btn {
        padding-left: 5px;
        cursor: pointer;
        font-size: 16px;
    }
    .remove_btn:hover {
        color: var(--danger);
    }
</style>

<script>

    import EditDraw from './StaffEditDrawer';
    import AddDraw from './StaffAddDrawer';


    export default {
        components: {
            AddDraw,
            EditDraw,
        },
        props: [
            "attr"
        ],
        data() {
            return {
                editItem: {},
                drawerLabel: "",
                showEdit: false,
                showAdd: false,

                form: {
                    keywords: "",
                    enable: null,
                },
                pager: {
                    pageSize: 12,
                    dataTotal: 0,
                    currentPage: 1
                },
                tableData: [ ],
                showSSO: false,
            }

        },

        watch: {
            "form": {
                handler: function (newValue) {
                    this.pager.currentPage = 1;
                    this.loadData();
                },
                deep: true

            }
        },

        methods: {
            add() {
                this.editItem = {};
                this.showAdd = true;
            },
            edit(item) {
                this.editItem = {...item};
                this.showEdit = true;

            },


            modifyEnable(item) {
                this.$ajaxGet("/user/toggleEnable/" + item.id + "-" + item.enable);
            },

            loadData() {
                this.$ajaxPost("/user/list", {
                    form: this.form,
                    isStaff: true,
                    pager: {...this.pager, dataTotal: 0}
                }, (data) => {
                    //分页不能带offset，否则会影响后台计算最新offset
                    let {offset, ...pager} = data.pager;
                    this.pager = pager;
                    this.tableData = data.result;
                    this.showEdit = false;
                    this.showAdd = false;
                })
            },
            pageChange(page) {
                this.pager.currentPage = page;
                this.loadData();
            },

            remove(staff) {
                this.$ajaxGet("/user/removeStaff/" + staff.positionId, data => {
                    this.loadData();
                })
            }

        },
        mounted() {
            this.showSSO = window.location.host.startsWith(process.env.VUE_APP_SSO_HOST+".");
        },
        created() {
            this.loadData();
        }

    }
</script>
